import React, { forwardRef, useState } from "react";
import ThermalPrintHeader from "../../print/ThermalPrintHeader";

const SalesReportThermalPrint = forwardRef((salesRecord, ref) => {
  const [salesDetails, setSalesDetails] = useState(salesRecord.salesRecord);

  // Preprocess data to calculate row spans
  let salesRowSpanData = {};
  salesDetails.forEach((row, index) => {
    if (salesRowSpanData[row.SalesNo]) {
      salesRowSpanData[row.SalesNo].count += 1;
    } else {
      salesRowSpanData[row.SalesNo] = { count: 1, index };
    }
  });

  const processedData = salesDetails.map((row, index) => {
    if (salesRowSpanData[row.SalesNo].index === index) {
      return {
        ...row,
        rowSpan: salesRowSpanData[row.SalesNo].count,
      };
    }
    return { ...row, rowSpan: 0 };
  });

  const getTamilDayName = (englishDayName) => {
    const dayNameMap = {
      Monday: "திங்கள்",
      Tuesday: "செவ்வாய்",
      Wednesday: "புதன்",
      Thursday: "வியாழன்",
      Friday: "வெள்ளி",
      Saturday: "சனி",
      Sunday: "ஞாயிறு",
    };
    return dayNameMap[englishDayName] || englishDayName;
  };

  return (
    <div ref={ref} style={{ width: "80mm", fontSize: "15px" }}>
      <ThermalPrintHeader />
      {/* <div style={{ textAlign: "center" }}>
        <p style={{ fontSize: "14px", fontWeight: 900, paddingLeft:"50px" }}>
          MAR & SONS FISH COMPANY
        </p>
        <p style={{ fontSize: "14px", fontWeight: 900, paddingLeft:"50px" }}>
          Shop No:7 Sandhaipettai Fish Market
        </p>
        <p style={{ fontSize: "14px", fontWeight: 900, paddingLeft:"50px" }}>
          Thennampalayam, Tirupur 641 604.
        </p>
        <p style={{ fontSize: "14px", fontWeight: 900, paddingLeft:"50px" }}>
          9952624050, 9500591327, 9894777656
        </p>
      </div> */}
      <p style={{ textAlign: "center", fontWeight: 900, paddingLeft: "50px" }}>
        Sales Report
      </p>
      <table
        style={{
          marginTop: "10px",
          lineHeight: "1.5em",
          width: "100%",
        }}
      >
        <tbody>
          <tr>
            {/* <td
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                width: "25%",
                paddingLeft: "15px",
              }}
            >
              குறியீடு
            </td>
            <td
              style={{
                fontSize: "14px",
                width: "25%",
                fontWeight: "bold",
                whiteSpace: "nowrap",
                paddingLeft: "15px",
              }}
            >
              {": " + processedData[0].CustomerCode}
            </td> */}
            <td
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                width: "25%",
                paddingLeft: "100px",
              }}
            >
              பெயர்
            </td>
            <td
              style={{
                fontSize: "14px",
                // width: "25%",
                fontWeight: "bold",
                whiteSpace: "nowrap",
                paddingLeft: "10px",
              }}
            >
              {": " + processedData[0].CustomerName}
            </td>
          </tr>
        </tbody>
      </table>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th
              style={{
                border: "1px dashed",
                padding: "4px",
                fontWeight: 900,
                width: "20%",
                paddingLeft: "15px",
              }}
            >
              பொருள்
            </th>
            <th
              style={{
                border: "1px dashed",
                padding: "4px",
                fontWeight: 900,
                width: "30%",
              }}
            >
              அளவு
            </th>
            <th
              style={{
                border: "1px dashed",
                padding: "4px",
                fontWeight: 900,
                width: "20%",
              }}
            >
              விலை
            </th>
            <th
              style={{
                border: "1px dashed",
                padding: "4px",
                fontWeight: 900,
                width: "17%",
              }}
            >
              தொகை
            </th>
            <th
              style={{
                border: "1px dashed",
                padding: "4px",
                fontWeight: 900,
                width: "20%",
              }}
            >
              தேதி
            </th>
          </tr>
        </thead>
        <tbody>
          {processedData?.length > 0 ? (
            processedData.map((item, index) => {
              return (
                <tr key={index}>
                  <td
                    style={{
                      border: "1px dashed",
                      padding: "4px",
                      fontWeight: "bold",
                      textAlign: "center",
                      fontSize: "14px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {item.IName}
                  </td>
                  <td
                    style={{
                      border: "1px dashed",
                      padding: "4px",
                      fontWeight: "bold",
                      textAlign: "left",
                      fontSize: "14px",
                      whiteSpace: "nowrap", // Prevent wrapping
                    }}
                  >
                    {item.Quantity}
                  </td>
                  <td
                    style={{
                      border: "1px dashed",
                      padding: "4px",
                      fontWeight: "bold",
                      textAlign: "right",
                      fontSize: "14px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {item.UnitPrice}
                  </td>
                  <td
                    style={{
                      border: "1px dashed",
                      padding: "4px",
                      fontWeight: "bold",
                      textAlign: "right",
                      fontSize: "14px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {item.TotalAmount}
                  </td>
                  {item.rowSpan > 0 && (
                    <td
                      rowSpan={item.rowSpan}
                      style={{
                        border: "1px dashed",
                        padding: "4px",
                        fontWeight: "bold",
                        fontSize: "14px",
                      }}
                    >
                      <div
                        style={{
                          textAlign: "center",
                          lineHeight: "1.5em",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item.SalesDate}
                        <br />
                        {getTamilDayName(item.SalesDay)}
                        <br />
                        {item.CurrentAmount}
                      </div>
                    </td>
                  )}
                </tr>
              );
            })
          ) : (
            <tr>
              <td
                colSpan="5"
                style={{
                  textAlign: "center",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                No items available
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <table
        style={{
          width: "100%",
          marginTop: "10px",
          marginLeft: "43px",
          lineHeight: "1.5em",
        }}
      >
        <tbody>
          <tr>
            <td
              style={{
                width: "70%",
                textAlign: "right",
                fontSize: "14px",
                fontWeight: "bold",
                paddingRight: "50px",
                whiteSpace: "nowrap",
              }}
            >
              இந்த வார தொகை :
            </td>
            <td
              style={{
                width: "30%",
                textAlign: "right",
                fontSize: "14px",
                fontWeight: "bold",
                paddingRight: "45px",
                whiteSpace: "nowrap",
              }}
            >
              {processedData[0].SumofCurrentAmount}
            </td>
          </tr>
          <tr>
            <td
              style={{
                width: "70%",
                textAlign: "right",
                fontSize: "14px",
                fontWeight: "bold",
                paddingRight: "50px",
                whiteSpace: "nowrap",
              }}
            >
              பாக்கி தொகை :
            </td>
            <td
              style={{
                width: "30%",
                textAlign: "right",
                fontSize: "14px",
                fontWeight: "bold",
                paddingRight: "45px",
                whiteSpace: "nowrap",
              }}
            >
              {processedData[0].OpeningBalance}
            </td>
          </tr>
          <tr>
            <td
              style={{
                width: "70%",
                textAlign: "right",
                fontSize: "14px",
                fontWeight: "bold",
                paddingRight: "50px",
                whiteSpace: "nowrap",
              }}
            >
              மொத்த தொகை :
            </td>
            <td
              style={{
                width: "30%",
                textAlign: "right",
                fontSize: "14px",
                fontWeight: "bold",
                paddingRight: "45px",
                whiteSpace: "nowrap",
              }}
            >
              {parseFloat(
                parseFloat(processedData[0].SumofCurrentAmount) +
                  parseFloat(processedData[0].OpeningBalance)
              ).toFixed(2)}
            </td>
          </tr>
          <tr>
            <td
              style={{
                width: "70%",
                textAlign: "right",
                fontSize: "14px",
                fontWeight: "bold",
                paddingRight: "50px",
                whiteSpace: "nowrap",
              }}
            >
              வரவு தொகை :
            </td>
            <td
              style={{
                width: "30%",
                textAlign: "right",
                fontSize: "14px",
                fontWeight: "bold",
                paddingRight: "45px",
                whiteSpace: "nowrap",
              }}
            >
              {processedData[0].CollectionAmount}
            </td>
          </tr>
          <tr>
            <td
              style={{
                width: "70%",
                textAlign: "right",
                fontSize: "14px",
                fontWeight: "bold",
                paddingRight: "50px",
                whiteSpace: "nowrap",
              }}
            >
              இருப்பு தொகை :
            </td>
            <td
              style={{
                width: "30%",
                textAlign: "right",
                fontSize: "14px",
                fontWeight: "bold",
                paddingRight: "45px",
                whiteSpace: "nowrap",
              }}
            >
              {parseFloat(
                parseFloat(
                  parseFloat(processedData[0].SumofCurrentAmount) +
                    parseFloat(processedData[0].OpeningBalance)
                ) - parseFloat(processedData[0].CollectionAmount)
              ).toFixed(2)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
});

export default SalesReportThermalPrint;
